import { CUSTOMER_STATUSES, CustomerStatus } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';

export function getStatusDisplayLabel(status: CustomerStatus): string {
  switch (status) {
    case CUSTOMER_STATUSES.Active:
      return 'Active';
    case CUSTOMER_STATUSES.Inactive:
      return 'Inactive';
    case CUSTOMER_STATUSES.Suspended:
      return 'Churned';
    case CUSTOMER_STATUSES.Trial:
      return 'Trial';
    default:
      return raiseUnreachable(status);
  }
}
